import * as React from 'react';

import styles from './modal-body.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

ModalBody.defaultProps = {
    as: 'span',
};

export function ModalBody({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles['modal-body']}>{children}</Tag>;
}
